import { addHours } from 'date-fns'
import { StateType } from '../components/StateScreen'
import { DisplayPassage } from '../data/mappers'
import { filterPassageBeforeLimit } from './date.utils'

export function determineState({
  theoreticPassages,
  realtimePassages,
  realtimeError,
  theoreticError,
  tripIsNotServed,
  calibratedNow,
  queryParams,
}: {
  theoreticPassages: DisplayPassage[]
  realtimePassages: DisplayPassage[]
  realtimeError: boolean
  theoreticError: boolean
  tripIsNotServed: boolean
  calibratedNow: Date
  queryParams: {
    debug: boolean
    state: string | null
  }
}): StateType | null {
  const twoHoursInTheFuture = addHours(calibratedNow, 2)
  const limitedRealtimePassages = filterPassageBeforeLimit(
    realtimePassages,
    twoHoursInTheFuture,
  )
  const limitedTheoreticPassages = filterPassageBeforeLimit(
    theoreticPassages,
    twoHoursInTheFuture,
  )

  const noPassagesAvailable =
    theoreticPassages.length === 0 && realtimePassages.length === 0
  const bothRealtimeAndTheoreticHaveErrors = realtimeError && theoreticError

  if (queryParams.debug) {
    console.debug({
      theoreticPassages,
      realtimePassages,
      limitedRealtimePassages,
      limitedTheoreticPassages,
    })
  }

  if (noPassagesAvailable && bothRealtimeAndTheoreticHaveErrors) {
    return StateType.ERROR
  }
  if (queryParams.debug && queryParams.state === 'warning') {
    return StateType.WARNING
  }
  if (
    limitedRealtimePassages.length === 0 &&
    limitedTheoreticPassages.length === 0
  ) {
    return StateType.NO_PASSAGES
  }
  if (tripIsNotServed) {
    return StateType.DETOUR
  }
  return null
}
